export default __webpack_public_path__ + "static/media/1.586acd8f.jpg";